export default __webpack_public_path__ + "static/media/hex.aa9c1498.svg";